import { Box, Button, Divider, IconButton, MenuItem, Select, Typography } from '@mui/material';
import RuleRow from 'components/@home/@settings/Tabs/Agents/tagPanels/RuleRow';
import CloseIcon from 'mdi-react/CloseIcon';
import PlusIcon from 'mdi-react/PlusIcon';
import { arrayOf, func, number, object } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';

const newRule = () => ({ triggerType: 'tool_called' });

const RuleGroupCard = ({ group, index, availableTools, availableSkills, onChange, onRemove }) => {
  const rules = group.rules || [];

  const updateRule = (idx, next) => {
    const nextRules = rules.map((r, i) => (i === idx ? next : r));
    onChange({ ...group, rules: nextRules });
  };

  const removeRule = idx => {
    const nextRules = rules.filter((_, i) => i !== idx);
    onChange({ ...group, rules: nextRules });
  };

  const addRule = () => {
    onChange({ ...group, rules: [...rules, newRule()] });
  };

  const setLogic = logic => onChange({ ...group, logic });

  return (
    <Box
      sx={{
        border: 1,
        borderColor: 'divider',
        borderRadius: '8px',
        bgcolor: 'background.default',
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography sx={{ fontSize: theme => theme.typography.pxToRem(13.5), fontWeight: 600 }}>
          {I18n.t('AgenticChatFlow.TagsRuleGroupTitle', { n: index + 1 })}
        </Typography>
        <IconButton size="small" onClick={onRemove}>
          <CloseIcon size={18} />
        </IconButton>
      </Box>
      {rules.map((rule, idx) => (
        <Box key={idx}>
          {idx > 0 && (
            <Select
              size="small"
              sx={{ alignSelf: 'flex-start', minWidth: 80, my: 0.5, ml: 1 }}
              value={group.logic || 'and'}
              onChange={e => setLogic(e.target.value)}
            >
              <MenuItem value="and">{I18n.t('AgenticChatFlow.TagsLogicAnd')}</MenuItem>
              <MenuItem value="or">{I18n.t('AgenticChatFlow.TagsLogicOr')}</MenuItem>
            </Select>
          )}
          <RuleRow
            rule={rule}
            availableTools={availableTools}
            availableSkills={availableSkills}
            onChange={next => updateRule(idx, next)}
            onRemove={() => removeRule(idx)}
          />
          {idx < rules.length - 1 && <Divider />}
        </Box>
      ))}
      <Button
        variant="outlined"
        size="small"
        sx={{ alignSelf: 'flex-start', textTransform: 'none', mt: 1 }}
        startIcon={<PlusIcon size={16} />}
        onClick={addRule}
      >
        {I18n.t('AgenticChatFlow.TagsAddRule')}
      </Button>
    </Box>
  );
};

RuleGroupCard.propTypes = {
  group: object.isRequired,
  index: number.isRequired,
  availableTools: arrayOf(object).isRequired,
  availableSkills: arrayOf(object).isRequired,
  onChange: func.isRequired,
  onRemove: func.isRequired,
};

export default RuleGroupCard;
